import { render, staticRenderFns } from "./RatePlanCardv2.vue?vue&type=template&id=3d38c4cf&"
import script from "./RatePlanCardv2.vue?vue&type=script&lang=js&"
export * from "./RatePlanCardv2.vue?vue&type=script&lang=js&"
import style0 from "./RatePlanCardv2.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports